// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__Cna4m","inputDescription":"styles_inputDescription__1_xAa"};